import axios from 'axios'
import { BASE_URL } from '../../constants/config'


async function getChain(token) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/credit/chain`
    }
    return axios(options)
}

async function listUserCredit(token, userId, limit, skip) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip
        },
        url: `${BASE_URL}/admin/credit/${userId}`
    }
    return axios(options)
}

async function createCredit(token, userId, billPrice, remark) {
    const options = {
        method: 'post',
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            billPrice,
            remark
        },
        url: `${BASE_URL}/admin/credit/${userId}`
    }
    return axios(options)
}

async function listCredit(token, limit, skip) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip
        },
        url: `${BASE_URL}/admin/credit`
    }
    return axios(options)
}

export default {
    getChain,
    listUserCredit,
    createCredit,
    listCredit
}